import ProductHistoryCompany from './ProductHistoryCompany';

export default function mapProductHistoryCompany(company: { name: string }): ProductHistoryCompany {
	return new ProductHistoryCompany(company.name);
}
